module.exports = __webpack_public_path__ + "static/media/disc_login.8a922bfb.png";